var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EntityBuilder } from '@decahedron/entity';
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { File as FileEntity } from 'packages/core/File';
import { CancelablePromise } from 'packages/core/CancelablePromise';
import axios from 'axios';
import isNil from 'common/support/isNil';
var UploadsRepository = /** @class */ (function (_super) {
    __extends(UploadsRepository, _super);
    function UploadsRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = FileEntity;
        _this.url = '/api/v2/uploads';
        _this.timeout = 30000;
        return _this;
    }
    UploadsRepository.prototype.uploadFileForTalent = function (file, talentId, jobId, progressHandler) {
        var _this = this;
        var formData = new FormData();
        formData.set('file', file);
        formData.set('origin_name', file.name);
        formData.set('owner_type', 'talents');
        formData.set('owner_id', talentId.toString());
        if (!isNil(jobId)) {
            formData.set('job_id', jobId.toString());
        }
        var cancelSource = axios.CancelToken.source();
        var config = {
            cancelToken: cancelSource.token,
            onUploadProgress: progressHandler,
            timeout: this.timeout,
        };
        var uploadPromise = new CancelablePromise(function (resolve, reject) {
            _this.axios.post(_this.url, formData, config).then(function () { return resolve(); }).catch(reject);
        });
        uploadPromise.cancel = function () {
            cancelSource.cancel();
            uploadPromise.reject('canceled');
        };
        return uploadPromise;
    };
    UploadsRepository.prototype.uploadFileForCompany = function (file, companyId) {
        return __awaiter(this, void 0, Promise, function () {
            var formData, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.set('file', file);
                        formData.set('origin_name', file.name);
                        formData.set('owner_type', 'company');
                        formData.set('owner_id', companyId.toString());
                        return [4 /*yield*/, this.axios.post(this.url, formData)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, EntityBuilder.buildOne(FileEntity, result.data.data)];
                }
            });
        });
    };
    UploadsRepository.prototype.deleteFile = function (fileId) {
        return this.axios.delete(this.url + "/" + fileId);
    };
    return UploadsRepository;
}(AbstractRepository));
export { UploadsRepository };
